/** @jsx jsx */
import { Button, ButtonSize, FacebookIcon, Inline, LinkedinIcon, LinkIcon, XIcon } from "@eworkit/iris";
import { FC, useCallback, useRef } from "react";
import { jsx } from "theme-ui";

import { openShareWindow, TShareTarget } from "./service";

interface ShareIconsProps {
  url: string;
  size?: ButtonSize;
  onShared?: (method: TShareTarget | "link") => void;
}

export const ShareIcons: FC<ShareIconsProps> = ({ url, size, onShared }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleItemClick = useCallback(
    (target: TShareTarget) => {
      openShareWindow(target, url);
      onShared?.(target);
    },
    [url, onShared],
  );

  const handleCopyLinkClick = useCallback(() => {
    if (!inputRef.current) return;

    inputRef.current.select();
    document.execCommand("copy");

    onShared?.("link");
  }, [onShared]);

  return (
    <Inline alignItems="center">
      <Button
        size={size ?? "md"}
        variant="ghost"
        iconLeft={<FacebookIcon />}
        onClick={() => handleItemClick("facebook")}
      />
      <Button size={size ?? "md"} variant="ghost" iconLeft={<XIcon />} onClick={() => handleItemClick("twitter")} />
      <Button
        size={size ?? "md"}
        variant="ghost"
        iconLeft={<LinkedinIcon />}
        onClick={() => handleItemClick("linkedin")}
      />
      <Button size={size ?? "md"} variant="ghost" iconLeft={<LinkIcon />} onClick={handleCopyLinkClick} />

      <input
        ref={inputRef}
        readOnly={true}
        value={url}
        sx={{ width: 1, position: "absolute", opacity: 0, pointerEvents: "none" }}
      />
    </Inline>
  );
};
